
import React, { useContext, useState } from "react";
import { Table, Input, Button, Space } from "antd";
import { SearchOutlined, EditOutlined, DeleteOutlined, EnvironmentOutlined } from "@ant-design/icons";
import { WarehouseContext } from './'
import { Truck } from "react-feather";

const DataTables = () => {
    const [searchText, setSearchText] = useState("");
    const [filteredData, setFilteredData] = useState([]);


    const { wareHouseData, deleteUser, loader, setSelectWarehouseData, setAddModalOpen, setIsEditMode } = useContext(WarehouseContext)

    const handleSearch = (e) => {
        const value = e.target.value.toLowerCase();
        setSearchText(value);
        const filtered = wareHouseData.filter((item) =>
            Object.values(item).some((field) =>
                field.toString().toLowerCase().includes(value)
            )
        );
        setFilteredData(filtered);
    };

    const openMap = (latitude, longitude) => {
        const url = `https://www.google.com/maps?q=${latitude},${longitude}`;
        window.open(url, "_blank");
    };


    const getColumnSearchProps = (dataIndex) => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    placeholder={`Search ${dataIndex}`}
                    value={selectedKeys[0]}
                    onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => confirm()}
                    style={{ width: 188, marginBottom: 8, display: "block" }}
                />
                <Space>
                    <Button type="primary" onClick={() => confirm()} size="small" icon={<SearchOutlined />}>
                        Search
                    </Button>
                    <Button onClick={clearFilters} size="small">
                        Reset
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered) => <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />,
        onFilter: (value, record) => record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    });

    const getFilters = (data, key) => {
        const uniqueValues = [...new Set(data.map((item) => item[key]))];
        return uniqueValues.map((value) => ({ text: value, value }));
    };

    const columns = [
        {
            title: "Warehouse Name",
            dataIndex: "name",
            key: "name",
            sorter: (a, b) => a.name.localeCompare(b.name),
            ...getColumnSearchProps("name"),
        },
        {
            title: "Address",
            dataIndex: "address",
            key: "address",
            sorter: (a, b) => a.address.localeCompare(b.address),
        },
        {
            title: "City",
            dataIndex: "city",
            key: "city",
            filters: getFilters(wareHouseData, "city"),
            onFilter: (value, record) => record.city === value,
            sorter: (a, b) => a.city.localeCompare(b.city),
        },
        {
            title: "State",
            dataIndex: "state",
            key: "state",
            filters: getFilters(wareHouseData, "state"),
            onFilter: (value, record) => record.state === value,
            sorter: (a, b) => a.state.localeCompare(b.state),
        },
        {
            title: "Country",
            dataIndex: "country",
            key: "country",
            filters: getFilters(wareHouseData, "country"),
            onFilter: (value, record) => record.country === value,
            sorter: (a, b) => a.country.localeCompare(b.country),
        },
        {
            title: "Pincode",
            dataIndex: "pincode",
            key: "pincode",
        },
        {
            title: "Contact Phone",
            dataIndex: "contactPhone",
            key: "contactPhone",
            ...getColumnSearchProps("contactPhone"),
        },
        {
            title: "Manager",
            dataIndex: "manager",
            key: "manager",
            filters: getFilters(wareHouseData, "manager"),
            onFilter: (value, record) => record.manager === value,
            sorter: (a, b) => a.manager.localeCompare(b.manager),
        },
        {
            title: "Actions",
            key: "actions",
            render: (_, record) => (
                <Space size="middle">
                    <Button type="link" icon={<EditOutlined />} onClick={() => editWarehouse(record)} />
                    <Button type="link" icon={<DeleteOutlined />} danger onClick={() => deleteUser(record)} />
                    <Button
                        type="link"
                        icon={<EnvironmentOutlined />}
                        onClick={() => openMap(record.latitude, record.longitude)}
                    />
                </Space>
            ),
        },
    ];

    // Edit warehouse function
    const editWarehouse = (record) => {
        console.log("Edit Warehouse:", record);
        setIsEditMode(true)
        setSelectWarehouseData(record);
        setAddModalOpen(true)
    };

    return (
        <div>

            <Input
                placeholder="Search Warehouses..."
                prefix={<SearchOutlined />}
                value={searchText}
                onChange={handleSearch}
                style={{ marginBottom: 16, width: 300 }}
            />

            <Table
                columns={columns}
                dataSource={wareHouseData}
                pagination={{ pageSize: 5 }}
                rowKey="key"
                loading={loader}
            />
        </div>
    );
};

export default DataTables;
